import React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import './styles.scss';

// Patrocinadores
import agroBaggioJohnDeereLogo from '../../assets/images/patrocinadores/agro_baggio_john_deere_logo.png';
import amazoniaMaquinasLogo from '../../assets/images/patrocinadores/amazonia_maquinas_logo.png';
import aprosojaMtLogo from '../../assets/images/patrocinadores/aprosoja_mt_logo.png';
import cdlLrvLogo from '../../assets/images/patrocinadores/cdl_lrv_logo.png';
import codigoKidLogo from '../../assets/images/patrocinadores/codigo_kid_logo.png';
import fazendaManoJulioLogo from '../../assets/images/patrocinadores/fazenda_mano_julio_logo.png';
import focoSementesCiaLogo from '../../assets/images/patrocinadores/foco_sementes_cia_logo.png';
import inexaLogo from '../../assets/images/patrocinadores/inexa_logo.png';
import sicrediLogo from '../../assets/images/patrocinadores/sicredi_logo.png';
import solosEPlantasLogo from '../../assets/images/patrocinadores/solos_e_plantas_logo.png';

// Realização
import gpsatiLogo from '../../assets/images/realizacao/gpsati_logo.png';
import unilasalleLogo from '../../assets/images/realizacao/unilasalle_lrv_logo.png';

// Apoio
import ageliderLogo from '../../assets/images/apoiadores/agelider_logo.png';
import agrihubLogo from '../../assets/images/apoiadores/agrihub_logo.png';
import fundacaoRioVerdeLogo from '../../assets/images/apoiadores/fundacao_rio_verde_logo.png';
import hubnorteLogo from '../../assets/images/apoiadores/hubnorte_logo.png';

const Logo = ({
  alt,
  classNameImg,
  imgSrc,
  title
}) => (
  <div className="logo">
    <img
      alt={alt}
      className={classNameImg}
      src={imgSrc}
      title={title}
    />
  </div>
);

const Rodape = () => (
  <footer style={{ textAlign: 'center' }}>
    <Grid>
      <Row>
        <Col xs>
          <h4 className="destaque">Patrocinadores</h4>
        </Col>
      </Row>
      <Row>
        <Col xs>
          <Logo
            alt="Sicredi"
            classNameImg="scale70"
            imgSrc={sicrediLogo}
            title="Sicredi"
          />
        </Col>
      </Row>
      <Row>
        <Col xs>
          <Logo
            alt="Amazônia Máquinas e Implementos"
            classNameImg="scale50"
            imgSrc={amazoniaMaquinasLogo}
            title="Amazônia Máquinas e Implementos"
          />
        </Col>
        <Col xs>
          <Logo
            alt="Aprosoja - Mato Grosso"
            classNameImg="scale50"
            imgSrc={aprosojaMtLogo}
            title="Aprosoja - Mato Grosso"
          />
        </Col>
        <Col xs>
          <Logo
            alt="CDL - Lucas do Rio Verde"
            classNameImg="scale50"
            imgSrc={cdlLrvLogo}
            title="CDL - Lucas do Rio Verde"
          />
        </Col>
        <Col xs>
          <Logo
            alt="Fazenda Mano Julio"
            classNameImg="scale50"
            imgSrc={fazendaManoJulioLogo}
            title="Fazenda Mano Julio"
          />
        </Col>
      </Row>
      <Row>
        <Col xs>
          <Logo alt="Agro Baggio - John Deere" imgSrc={agroBaggioJohnDeereLogo} title="Agro Baggio - John Deere" />
        </Col>
        <Col xs>
          <Logo alt="Código Kid" imgSrc={codigoKidLogo} title="Código Kid" />
        </Col>
        <Col xs>
          <Logo alt="Foco Sementes & Cia" imgSrc={focoSementesCiaLogo} title="Foco Sementes & Cia" />
        </Col>
        <Col xs>
          <Logo alt="Inexa - Internet Banda Larga" imgSrc={inexaLogo} title="Inexa - Internet Banda Larga" />
        </Col>
        <Col xs>
          <Logo alt="Laboratório Solos & Plantas" imgSrc={solosEPlantasLogo} title="Laboratório Solos & Plantas" />
        </Col>
      </Row>
      <Row>
        <Col xs>
          <Row>
            <Col xs>
              <h4 className="destaque">Realização</h4>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <Logo alt="UniLasalle/Lucas" imgSrc={unilasalleLogo} title="UniLasalle/Lucas" />
            </Col>
            <Col xs>
              <Logo alt="GPSATi" imgSrc={gpsatiLogo} title="GPSATi" />
            </Col>
          </Row>
        </Col>
        <Col xs>
          <Row>
            <Col xs>
              <h4 className="destaque">Apoio</h4>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs>
              <Logo alt="Fundação Rio Verde" imgSrc={fundacaoRioVerdeLogo} title="Fundação Rio Verde" />
            </Col>
            <Col xs>
              <Logo alt="Agrihub" imgSrc={agrihubLogo} title="Agrihub" />
            </Col>
            <Col xs>
              <Logo alt="Hubnorte" imgSrc={hubnorteLogo} title="Hubnorte" />
            </Col>
            <Col xs>
              <Logo alt="Agelider" imgSrc={ageliderLogo} title="Agelider" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Grid
      fluid
      style={{
        backgroundColor: '#282a36',
        color: '#706f6f',
        padding: 15
      }}
    >
      <Row between="md">
        <Col xs={12} sm={12} md={6}>
          <span>&copy; 2020 Hackathon AgriTech - UniLasalle/Lucas</span>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <i>Desenvolvido com <i className="fa fa-heart" style={{ color: '#d12121' }} /> por <a href="https://www.unilasalle.edu.br/lucas-do-rio-verde/servicos/grupo-de-projetos-em-solucoes-para-o-agronegocio-e-tecnologia-da-informacao" target="_blank">GPSATi</a></i>
        </Col>
      </Row>
    </Grid>
  </footer>
);

export default Rodape;
